<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h1>{{ 'pages.shipmentReceiving.validateCourier.step1' | translate }}</h1>
      <p class="red">{{ 'pages.shipmentReceiving.validateCourier.getIdReady' | translate }}</p>
      <p class="">{{ 'pages.shipmentReceiving.validateCourier.scanForStart' | translate }}</p>
    </div>
    <div class="col-md-4 form-group">
      <div class="input-group {{searchCourierInProgress}}">
        <img src="../../assets/img/red-loader.gif" class="img-responsive loader-img" />
        <input type="text" class="form-control"
               (input)="changeCourierId()"
               [(ngModel)]="courierId"
               [placeholder]="'pages.shipmentReceiving.validateCourier.courireId' | translate">
        <span class="input-group-btn">
          <button class="btn  {{validCourier == true ? 'btn-success':'btn-primary'}}" type="button" (click)="validateCourier()" [innerHtml]="validateTxt"></button>
        </span>
      </div>
      <span class="red" *ngIf="CourierIdValid == false">{{ 'common.required' | translate }}</span>
    </div>
  </div>
  <div *ngIf="showCourierSection" class="courier-details">
    <div *ngIf="courier.showCourierSection ">
      <div class="row card-id">
        <div class="col-md-12">
          <h4>{{ 'pages.shipmentReceiving.validateCourier.courierName&Number' | translate }}</h4>
          <div class="card-details">
            <h4 class="red">{{courier.name}}</h4>
            <h4>{{courier.courierId}}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="row card-id" *ngIf="courier.showLocationAssignedSection">
      <div class="col-md-12">
        <h4>{{ 'pages.shipmentReceiving.validateCourier.spotLocation' | translate }}</h4>
        <div class="card-details">
          <h5 class="red">{{courier.location}}</h5>
          <p>{{courier.city}}</p>
        </div>
      </div>
    </div>
    <div class="row card-id" *ngIf="courier.showNumberOfShipments">
      <div class="col-md-12">
        <h4>{{ 'pages.shipmentReceiving.validateCourier.numberAndShipment' | translate }}</h4>
        <div class="card-details">
          <h5 class="red">{{courier.shipmentsCount}}</h5>
          <p>{{ 'pages.shipmentReceiving.shipments' | translate }}</p>
        </div>
      </div>
    </div>
    <div class="row card-id" *ngIf="courier.showErrorMessage">
      <div class="col-md-12">
        <div class="alert alert-danger" *ngIf="startEnabled == false">
          <h4>{{courier.errorMessage}}</h4>
          <p *ngIf="courier.errorMessage != 'No courier found'">{{ 'pages.shipmentReceiving.validateCourier.checkMsg' | translate }}</p>
        </div>
      </div>
    </div>

    <button class="btn-lg btn-primary {{startEnabled ? '':'btn-disabled' }}" (click)="start()">{{ 'common.start' | translate }}</button>
  </div>
</div>
